import { AgsSparkBehaviour } from "ags/behaviours/ags-spark-behaviour";
import { TrailDisplayComponent } from "ags/components/trail-display";
import { SparkResult } from "ags/integration/model/results/spark-result";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { SymbolSubcomponent } from "slotworks/components/matrix/symbol/symbol-subcomponent";
import { AgsSpin } from "./ags-spin";

interface SparkData {
    x: number;
    y: number;
    upgradeLevel?: number;
}

export class AgsSparkSpin extends AgsSpin {

    protected behaviours = new Map<SymbolSubcomponent, AgsSparkBehaviour>();
    protected behavioursFinished: boolean;
    protected spinFinished: boolean;
    protected numberOfSparks = 0;

    public onEnter(): void {
        super.onEnter();
        this.behavioursFinished = true;
        this.spinFinished = false;
        this.numberOfSparks = 0;
        this.attachWildBehaviours();
    }

    public complete(behavioursComplete?: boolean) {
        if (behavioursComplete) {
            this.behavioursFinished = true;
        } else {
            this.spinFinished = true;
        }

        if (this.spinFinished && this.behavioursFinished) {
            super.complete();
        }
    }

    public onExit() {
        this.behaviours.forEach((behaviour, symbol) => {
            behaviour.destroy();
            symbol.removeBehaviour(behaviour);
        });

        this.behaviours.clear();

        super.onExit();
    }

    protected attachWildBehaviours() {
        const wildSymbolPositions: SparkData[] = [];
        const sparkResult = gameState.getCurrentGame().getCurrentRecord().getFirstResultOfType(SparkResult);

        if (sparkResult != null && sparkResult.positions.length > 0) {
            for (const position of sparkResult.positions) {
                wildSymbolPositions.push({ x: position.x, y: position.y });
            }

            if (sparkResult.upgrade) {
                wildSymbolPositions[Math.floor(Math.random() * wildSymbolPositions.length)]
                    .upgradeLevel = sparkResult.state;
            }
        }

        wildSymbolPositions.forEach((symbolPosition) => {
            const symbol = Components.get(MatrixComponent).getSymbol(symbolPosition.x, symbolPosition.y);
            const behaviour = this.createWildBehaviour(symbol, symbolPosition.upgradeLevel);
            symbol.addBehaviour(behaviour);
            behaviour.animationComplete.addOnce(() => this.sparkComplete());

            this.behaviours.set(symbol, behaviour);
            this.behavioursFinished = false;
            this.numberOfSparks++;
        });
    }

    protected createWildBehaviour(symbol: SymbolSubcomponent, upgradeLevel: number) {
        return new AgsSparkBehaviour(symbol, upgradeLevel, Components.get(TrailDisplayComponent));
    }

    protected sparkComplete() {
        this.numberOfSparks--;

        if (this.numberOfSparks <= 0) {
            this.complete(true);
        }
    }
}
